export default "__VITE_ASSET__EfdZyqWE__"